/**
 * Coure.RateBillingManagement.API 
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Currency = 1 | 2 | 3 | 4;

export const Currency = {
    NUMBER_1: 1 as Currency,
    NUMBER_2: 2 as Currency,
    NUMBER_3: 3 as Currency,
    NUMBER_4: 4 as Currency
};